import { render, staticRenderFns } from "./CalendarEventReminder.vue?vue&type=template&id=1c231ded&scoped=true"
import script from "./CalendarEventReminder.vue?vue&type=script&lang=ts"
export * from "./CalendarEventReminder.vue?vue&type=script&lang=ts"
import style0 from "./CalendarEventReminder.vue?vue&type=style&index=0&id=1c231ded&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c231ded",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c231ded')) {
      api.createRecord('1c231ded', component.options)
    } else {
      api.reload('1c231ded', component.options)
    }
    module.hot.accept("./CalendarEventReminder.vue?vue&type=template&id=1c231ded&scoped=true", function () {
      api.rerender('1c231ded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarEventReminder.vue"
export default component.exports